import { ExtranetProductShortageListItemDto } from '@pharmac-extranet/extranet-api'
import {
  ExtranetCatalogItemChevron,
  ExtranetExpandArrowColumn,
  ExtranetTableColumn,
  ExtranetTableGroupColumn,
  ExtranetTableRow,
  useBreakpoint,
} from '@pharmac-extranet/shared'
import { ProductShortageTable } from './ProductShortagesTable'

type Props = {
  item: ExtranetProductShortageListItemDto
}

export const ProductShortageItem = ({ item }: Props) => {
  const { maxMobile } = useBreakpoint()

  return (
    <ExtranetTableRow
      expand={<ProductShortageTable orders={item.orders} />}
      toggleExpand={() => null}
      children={({ isExpanded }) => (
        <ExtranetTableGroupColumn>
          <ExtranetTableRow>
            <ExtranetTableColumn
              marginSmallLeft
              size={maxMobile ? 1.5 : 0}
              style={{ fontWeight: 600, overflowWrap: 'anywhere' }}
            >
              {item.groupName}
            </ExtranetTableColumn>
            <ExtranetTableColumn>{item.ordersCount}</ExtranetTableColumn>
            <ExtranetExpandArrowColumn>
              <ExtranetCatalogItemChevron isExpanded={isExpanded} />
            </ExtranetExpandArrowColumn>
          </ExtranetTableRow>
        </ExtranetTableGroupColumn>
      )}
    />
  )
}
